import { render, staticRenderFns } from "./TariffSchedule.vue?vue&type=template&id=a3512a18&"
import script from "./TariffSchedule.vue?vue&type=script&lang=js&"
export * from "./TariffSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TariffSchedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports